import { API_URL, ASSET_BASE_URL } from '@/utils/env-setup';

const trimTrailingSlash = (value: string) => {
  return value.replace(/\/+$/, '');
};

const trimLeadingSlash = (value: string) => {
  return value.replace(/^\/+/, '');
};

const removeTrailingPathSegment = (value: string, segment: string) => {
  const trimmedValue = trimTrailingSlash(value);
  const suffix = `/${segment}`;
  if (trimmedValue.toLowerCase().endsWith(suffix.toLowerCase())) {
    return trimmedValue.slice(0, trimmedValue.length - suffix.length);
  }
  return trimmedValue;
};

const tryParseUrl = (value: string, base?: string) => {
  try {
    return base ? new URL(value, base) : new URL(value);
  } catch (error) {
    return undefined;
  }
};

const buildAssetBaseUrl = () => {
  if (ASSET_BASE_URL && ASSET_BASE_URL.trim().length > 0) {
    return trimTrailingSlash(ASSET_BASE_URL);
  }

  if (API_URL && API_URL.trim().length > 0) {
    const trimmedApiUrl = API_URL.trim();
    const parsedApiUrl =
      tryParseUrl(trimmedApiUrl) ||
      (typeof window !== 'undefined' && window.location?.origin
        ? tryParseUrl(trimmedApiUrl, window.location.origin)
        : undefined);

    if (parsedApiUrl) {
      const sanitizedPath = removeTrailingPathSegment(parsedApiUrl.pathname, 'api');
      const assetPath = `${sanitizedPath}/assets/images`;
      const normalizedAssetPath = assetPath.startsWith('/')
        ? assetPath
        : `/${assetPath}`;
      return trimTrailingSlash(`${parsedApiUrl.origin}${normalizedAssetPath}`);
    }

    const manualBase = removeTrailingPathSegment(trimmedApiUrl, 'api');
    if (manualBase.length === 0) {
      return '/assets/images';
    }

    if (manualBase.startsWith('http://') || manualBase.startsWith('https://')) {
      return trimTrailingSlash(`${manualBase}/assets/images`);
    }

    if (manualBase.startsWith('/')) {
      return trimTrailingSlash(`${manualBase}/assets/images`);
    }

    const relativePath = `/${trimLeadingSlash(`${manualBase}/assets/images`)}`;
    return trimTrailingSlash(relativePath);
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    const assetUrl = new URL('/assets/images', window.location.origin).toString();
    return trimTrailingSlash(assetUrl);
  }

  return '/assets/images';
};

const assetBaseUrl = buildAssetBaseUrl();

export const getAssetUrl = (fileName: string) => {
  return `${assetBaseUrl}/${trimLeadingSlash(fileName)}`;
};
